import React from "react";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";

function Shop() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="shop main">
      <section className="featured-section">
        <div className="section-header">
          <h2>SHOP ALL</h2>
        </div>
        <div className="products-grid">
          {productData.map((product) => (
            <Link
              to={`/shopDetails/${product.id}`}
              key={product.id}
              onClick={toTop}
              className="product-card"
            >
              <div className="product-image">
                <img
                  src={product.image.replace(".jpeg", ".webp")}
                  alt={product.name}
                />
              </div>
              <div className="product-info">
                <h3 className="product-name">{product.name}</h3>
                <p className="product-price">${product.price}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Shop;
